export default "__VITE_ASSET__C7UI_$Ky__"